<template>
  <div id="page" class="site">
    <div id="feather" class="feather"></div>
    <main id="content" class="site-content" role="main">
      <section id="intro" class="full-screen">
        <h1 class="text-primary-700 text-4xl lg:text-7xl text-center font-sigmar tracking-wider">
          Découvrez <br> notre histoire
        </h1>
        <p class="w-full lg:w-1/2 text-xl my-10 text-center text-primary-700 mx-auto">
          Découvrez l'histoire de Déglingo pas à pas et plongez au cœur de notre aventure.
          Chaque étape vous révélera nos secrets !
        </p>
        <div id="clouds-layer-1" class="clouds"></div>
        <div id="clouds-layer-2" class="clouds"></div>
      </section>

      <section id="panels" style="overflow: hidden">
        <div id="panels-container" style="width: 700%;">
          <article
              v-for="(panel, index) in panels"
              :key="panel.id"
              :id="panel.id"
              class="panel full-screen"
              :class="panel.gradient"
          >
            <div class="w-full h-full flex items-center justify-center bg-primary-700">
              <div class="flex items-center justify-around">
                <div class="col-6">
                  <img :src="panel.image" alt="" />
                </div>
                <div class="w-full mx-5 lg:w-1/2 text-white">
                  <h1 class="text-8xl font-sigmar tracking-wider my-5">{{ panel.year }}</h1>
                  <h2 class="font-sigmar tracking-wider text-4xl my-5">{{ panel.title }}</h2>
                  <p class="step-description">{{ panel.description }}</p>
                  <div class="panels-navigation">
                    <div v-if="index > 0" class="nav-panel" data-sign="minus">
                      <a :href="panels[index - 1].href" data-target="0" class="anchor">Prev</a>
                    </div>
                    <div v-if="index < panels.length - 1" class="nav-panel" data-sign="plus">
                      <a :href="panels[index + 1].href" data-target="1" class="anchor">Next</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </article>
        </div>
      </section>

      <section id="intro" class="full-screen gradient-orange flex items-center justify-center">
        <h1 class="text-primary-700 text-4xl lg:text-7xl text-center font-sigmar tracking-wider">
          Merci <br> pour votre soutien
        </h1>
        <p class="w-full lg:w-1/2 text-xl my-10 text-center text-primary-700 mx-auto">
          Vous êtes désormais incollable sur l'histoire de déglingo, vous faites partis de nos plus fidèle déglingo !
        </p>
      </section>
    </main>
  </div>
</template>

<script>
import gsap from "gsap";
import { ScrollToPlugin, ScrollTrigger } from "gsap/all";

export default {
  name: "HistoireView",
  data() {
    return {
      panels: [
        {
          id: "panel-1",
          year: '1994',
          title: "Une idée au coin du feu",
          description: "Un soir d’été, Lucas, Nicolas, Séb (toufik) et Mattéo, quatre amis d’enfance, partagent une soirée autour d’un feu de camp dans les forêts du sud-ouest. Inspirés par leur amour des moments simples, ils imaginent une bière artisanale unique et audacieuse : la Déglingo. Le nom est choisi dans un éclat de rire, à l’image de leur amitié.",
          gradient: "gradient-green",
          href: "#panel-1",
          image: "",
        },
        {
          id: "panel-2",
          year: '1995',
          title: "L’expérimentation en garage",
          description: "Dans le garage de Mattéo, les amis transforment de vieux fûts et bricolent leur première micro-brasserie. Après de nombreux essais (et quelques échecs !), ils créent la Déglingo Originale, une blonde corsée, qu’ils commencent à vendre dans les fêtes locales.",
          gradient: "gradient-blue",
          href: "#panel-2",
          image: "",
        },
        {
          id: "panel-223",
          year: '1996',
          title: "Glingo, le sanglier vagabond",
          description: "Durant ces mêmes randonnées, ils croisent souvent un sanglier un peu particulier : un vieux mâle costaud et curieux qui semble toujours les suivre. Ils décident de le nommer Glingo. Sa force brute et son esprit libre deviennent rapidement la mascotte parfaite pour leur bière.",
          gradient: "gradient-blue",
          href: "#panel-2",
          image: "",
        },
        {
          id: "panel-3",
          year: '1998',
          title: "L’ouverture de la brasserie",
          description: "Encouragés par leur succès local, ils louent une ancienne grange et ouvrent officiellement leur brasserie. Leur devise, \"La bière qui libère l’animal en toi\", reflète leur esprit rebelle et créatif. Ils lancent aussi deux nouvelles recettes officielles : la Déglingo Blonde et la Déglingo Brune.",
          gradient: "gradient-green",
          href: "#panel-3",
          image: "",
        },
        {
          id: "panel-4",
          year: '2002',
          title: "Un prix au Salon de la Bière Artisanale",
          description: "La Déglingo Blonde remporte un prix prestigieux au Salon de la Bière Artisanale à Bordeaux. Ce succès leur permet de commencer à distribuer leurs bières dans les bars et restaurants de la région. L’étiquette, illustrant leur mascotte Glingo le sanglier, devient leur signature.",
          gradient: "gradient-blue",
          href: "#panel-4",
          image: "",
        },
        {
          id: "panel-5",
          year: '2008',
          title: "Une expansion régionale",
          description: "La brasserie modernise sa production et s’ouvre à de nouveaux marchés. Avec des bouteilles redessinées par des artistes locaux, Déglingo gagne encore en popularité. La marque devient un incontournable des soirées festives et des événements culturels.",
          gradient: "gradient-green",
          href: "#panel-5",
          image: "",
        },
        {
          id: "panel-6",
          year: '2024',
          title: "Une Référence Artisanale",
          description: "Après 30 ans d’aventure, Déglingo est une marque emblématique. Toujours dirigée par Lucas, Nicolas, Seb (toufik) et Mattéo, la brasserie propose des bières originales, comme la Glingo Sauvage (vieillie en fût de chêne), et collabore avec des brasseries du monde entier.",
          gradient: "gradient-green",
          href: "#panel-6",
          image: "",
        }
      ]
    };
  },
  mounted() {
    gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);

    const panels = gsap.utils.toArray("#panels-container .panel");
    const panelsContainer = document.querySelector("#panels-container");

    gsap.to(panels, {
      xPercent: -100 * (panels.length - 1),
      ease: "none",
      scrollTrigger: {
        trigger: "#panels-container",
        pin: true,
        start: "top top",
        scrub: 1,
        snap: {
          snapTo: 1 / (panels.length - 1),
          inertia: false,
          duration: { min: 0.1, max: 0.1 },
        },
        end: () => `+=${panelsContainer.offsetWidth - window.innerWidth}`,
      },
    });

    document.querySelectorAll(".anchor").forEach((anchor) => {
      anchor.addEventListener("click", (e) => {
        e.preventDefault();
        const targetElem = document.querySelector(e.target.getAttribute("data-target"));
        if (!targetElem) return;

        const y = targetElem.offsetTop;
        gsap.to(window, { scrollTo: { y, autoKill: false }, duration: 1 });
      });
    });
  },
};
</script>

<style scoped>
/* Most of these styles could be removed but are for the demo to look better */

.full-screen {
  display: block;
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

#intro {
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: var(--color-just-black);
}

#masthead {
  position: fixed;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  z-index: 9999;
}
#masthead a {
  padding: 1rem 2rem;
}


#panels #panels-container {
  height: 100vh;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  padding: 0;
  overflow: hidden;
  background-color: #ddd;
}
#panels #panels-container .panel {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  display: flex;
  text-align: left;
  align-items: center;
  justify-content: center;
}
#panels #panels-container .panel img {
  max-width: 100%;
  height: auto;
  display: block;
}
#panels #panels-container .panel .panels-navigation {
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: end;
  -ms-flex-pack: end;
  justify-content: flex-end;
}
#panels #panels-container .panel .anchor-panel,
#panels #panels-container .panel .nav-panel {
  text-transform: uppercase;
  margin-right: 2rem;
}
#panels #panels-container .panels-navigation {
  position: absolute;
  width: 100%;
  bottom: 2rem;
  right: 2rem;
}

a {
  color: white;
}
</style>
